module.exports = __webpack_public_path__ + "img/product-wrap-bg.8495bb7c.png";